import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "@/components/customAxios/Axios";
import { useLoader } from "@/context/loaderContext";
import { useToast } from "@/components/toast";
const VerifyToken = () => {
	const params = useParams();
	const navigate = useNavigate();
	const { setLoading } = useLoader();
	const toast = useToast();
	const verifyToken = async () => {
		try {
			setLoading(true);
			const response = await api.post("/decode_token", {
				token: params.token,
			});

			if (response.status == 200) {
				const {
					user_id,
					first_name,
					last_name,
					role,
					email,

					company_id,
					is_company_admin,
				} = response.data.payload;
				localStorage.clear();
				localStorage.setItem("authToken", `${params.token?.toString()}`);

				localStorage.setItem("user", user_id);
				localStorage.setItem("firstName", first_name);
				localStorage.setItem("lastName", last_name);
				localStorage.setItem("email", email);

				localStorage.setItem("role", role);
				localStorage.setItem("companyId", company_id);
				localStorage.setItem("isCompanyAdmin", is_company_admin);
				localStorage.setItem("googleLogin", "true")
				navigate("/home");

				window.location.reload();
			}
		} catch (error: any) {
			navigate("/login");
			toast.error({
				title: "Error",
				description: error.response?.data?.message || error.response?.data?.error || "Login failed",
				duration: 5000,
				open: true,
				status: "error",
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		verifyToken();
	}, []);
	return (
		<div className="bg-gray-50 flex justify-center items-center h-screen">
			<h3 className="text-3xl font-heading">Verifying Profile</h3>
		</div>
	);
};

export default VerifyToken;
